import type {
  CreateCertificationInput,
  UpdateCertificationInput,
  WorkerCertification,
} from "@crewledger/shared/schemas";
import { apiFetch } from "@/lib/api";

export async function fetchWorkerCertifications(workerId: string) {
  return apiFetch<{ data: WorkerCertification[] }>(`/api/certifications/worker/${workerId}`);
}

export async function createWorkerCertification(workerId: string, input: CreateCertificationInput) {
  return apiFetch<{ data: WorkerCertification }>(`/api/certifications/worker/${workerId}`, {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export async function updateWorkerCertification(id: string, input: UpdateCertificationInput) {
  return apiFetch<{ data: WorkerCertification }>(`/api/certifications/${id}`, {
    method: "PATCH",
    body: JSON.stringify(input),
  });
}

export { CERTIFICATION_TYPE_LABELS } from "@crewledger/shared/schemas";
